import { CoordinationCardStatuses } from './CoordinationCardStatuses';
import { Event as ServerEvent } from 'server/models/Event';
import { EventType } from './EventType';

export { EventData, EventOptions } from 'server/models/Event';

export class Event extends ServerEvent {
    ActorName() {
        return this.User()?.FullName() ?? this.Automation()?.Name() ?? null;
    }

    ActorAbbreviatedName() {
        return this.User()?.AbbreviatedName() ?? this.Automation()?.Name() ?? null;
    }

    /**
     * Return the event that we think best explains why this C-Card status update happened.
     */
    CCardStatusUpdateCause() {
        // Throw on incorrect EventType on the thinking that calling code should be able to check this easily.
        if (this.Type() !== EventType.CCardStatusUpdate) {
            throw new Error(`CCardStatusUpdateCause requires event type ${EventType.CCardStatusUpdate} but instead found type ${this.Type()}.`);
        }

        const lazyGuess : Event = this;

        const ccv = this.CoordinationCardVersion();
        // Give up trying to improve our guess if we don't have enough data loaded.
        if (ccv === null) return lazyGuess;

        // A status update to any status besides Pending is sui generis. No reason to look any further.
        if (ccv.StatusId() !== CoordinationCardStatuses.Pending) return lazyGuess;

        // We expect provider changes to trigger status resets. If we find a provider change, call that the
        // reason.
        let betterGuess = ccv.EventsAbout().find(ev => ev.Type() === EventType.CCardProviderChanged);
        if (betterGuess) return betterGuess;

        // TODO: Could try to dig further, like look up contemporaneous changes to the given PortCall's itinerary
        // and try to give a really granular answer. But in practice, our main use case for this method is to
        // distinguish status resets due to a specific known change to this C-Card entity (like provider change)
        // vs status resets due to any number of possible milestone updates. So giving up here is fine for now.

        return lazyGuess;
    }
}



// WEBPACK FOOTER //
// ./data/models/Event.ts